module.exports = __webpack_public_path__ + "static/media/crossIcon.c5ee62be.svg";